import { frontendURL } from '../../../helper/URLHelper';
import Index from '../settings/branches/Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/branches'),
    name: 'branches_dashboard_index',
    component: Index,
    meta: { permissions: ['administrator'] },
  },
];
